// extracted by mini-css-extract-plugin
export default {"container":"ProductCard_container__PgTXk","image":"ProductCard_image__UUHr9","title":"ProductCard_title__zlKnT"};